import constants from '../../../constants';

export default (data, state) => {
  const localData = data.id ?
  { ...state.data.posts[data.id], hasFailed: false } :
  {
    author: data.author.id,
    isTemporary: true,
    hasFailed: false,
    id: `${constants.TEMPORARY_PREFIX}${Date.now()}`,
    group: data.group.id,
    image: data.image,
    postTypeId: data.postTypeId,
  };

  const queryData = {
    groupCode: data.group.groupCode,
    userId: data.author.id,
    username: data.author.username,
  };

  const commonData = {
    title: data.title,
    body: data.body,
    isPrivate: data.isPrivate,
    // isActive: data.isActive,
    // isPinned: data.isPinned,
    // categoryId: data.categoryId,
    // excludeTags: data.excludeTags,
    // mentionedUserIds: data.mentionedUserIds,
  };

  return { localData, queryData, commonData };
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/posts/formatComposeData.js